// src/utils/alertUtils.js
import Swal from 'sweetalert2';

export const showAccessDeniedAlert = (navigate) => {
    Swal.fire({
        title: 'Access Denied',
        text: "You do not have permission. Please contact your Administrator to request access.",
        icon: 'error',
        showCancelButton: false,
        confirmButtonColor: '#121136',
        cancelButtonColor: '#EF3D50',
        confirmButtonText: 'Ok',
        allowOutsideClick: false,
        allowEscapeKey: false
    }).then((result) => {
        if (result.isConfirmed) {
            navigate(-1);
        }
    });
};
